import { css } from '@emotion/css';

import { mobileMediaQuery, nonMobileMediaQuery } from '../../constants';
import { m } from '../../motif/m';
import { FontFamily } from '../Font/fontConstants';

export const bigQuoteCss = css`
  font-size: 40px;
  line-height: 40px;
  margin-bottom: -20px;
  margin-top: -8px;
`;

export const startQuoteCss = css`
  margin-inline-start: -16px;
  text-align: start;
`;

export const endQuoteCss = css`
  margin-inline-end: -20px;
  text-align: end;
`;

export const quoteCss = css`
  padding: ${m('--spacing-xl')};
  border-radius: ${m('--border-radius-l')};

  background-color: ${m('--quote-bg-color')};
  color: ${m('--quote-fg-color')};
  box-shadow: ${m('--box-shadow-s')};

  font-family: ${m('--h5-font-family')};
  font-size: ${m('--h5-desktop-font-size')};
  font-weight: ${m('--h5-desktop-font-weight')};
  line-height: 120%;

  width: 600px;

  ${nonMobileMediaQuery} {
    text-align: center;
  }

  ${mobileMediaQuery} {
    text-align: left;
  }
`;

export const quoteIconCss = css`
  font-family: ${FontFamily.PROGRAM_OT}, Helvetica, Tahoma, Arial, sans-serif;
  color: ${m('--action-text-active-color')};
  font-size: 150px;
  line-height: 160px;
  margin-bottom: -60px;
  margin-top: -20px;
`;

export const authorCss = css`
  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ${nonMobileMediaQuery} {
    font-size: ${m('--quote-author-desktop-font-size')};
    font-weight: ${m('--quote-author-desktop-font-weight')};
    text-align: center;
  }

  ${mobileMediaQuery} {
    font-size: ${m('--quote-author-mobile-font-size')};
    font-weight: ${m('--quote-author-mobile-font-weight')};
    text-align: left;
  }
`;

// Single quote variants - force left alignment on all screen sizes
export const quoteCssWithVisualTestimonyCss = css`
  ${quoteCss}
  && {
    text-align: left;
  }
`;

export const authorCssWithVisualTestimonyCss = css`
  ${authorCss}
  && {
    text-align: left;
  }
`;
